import PropTypes from "prop-types";
import { Controller, useFormContext } from "react-hook-form";

import { Checkbox, FormControlLabel, Paper } from "@mui/material";
import Grid from "@mui/material/Grid";

import { ReturnableTypeEnum } from "../../returnable-type";
import { OutletWarehouseSelect } from "@/features/warehouses";

export const OtherSection = ({ editMode = false }) => {
  const { control, watch } = useFormContext();

  const seller = watch("seller");
  const returnableType = watch("returnableType");
  const taxable = watch("taxable");

  return (
    <Paper sx={{ p: 2.5, borderRadius: 2 }}>
      <Grid container spacing={2.5}>
        {returnableType === ReturnableTypeEnum.NON_INVOICE && (
          <Grid size={12}>
            <Controller
              control={control}
              name="warehouse"
              render={({ field, fieldState }) => (
                <OutletWarehouseSelect
                  outletId={seller?.id}
                  value={field.value}
                  onChange={field.onChange}
                  disabled={!seller}
                  TextFieldProps={{
                    label: "Gudang",
                    required: true,
                    error: fieldState.invalid,
                    helperText: fieldState.error?.message,
                  }}
                />
              )}
            />
          </Grid>
        )}
        <Grid container spacing={1}>
          <Grid>
            <Controller
              name="taxable"
              control={control}
              render={({ field }) => (
                <FormControlLabel
                  control={
                    <Checkbox
                      {...field}
                      checked={field.value || false}
                      onChange={(e) => field.onChange(e.target.checked)}
                      disabled={editMode}
                    />
                  }
                  label="Kena Pajak"
                />
              )}
            />
          </Grid>
          <Grid>
            <Controller
              name="totalIncludesTax"
              control={control}
              render={({ field }) => (
                <FormControlLabel
                  disabled={!taxable || editMode}
                  control={
                    <Checkbox
                      {...field}
                      checked={field.value || false}
                      onChange={(e) => field.onChange(e.target.checked)}
                      disabled={!taxable || editMode}
                    />
                  }
                  label="Total Termasuk Pajak"
                />
              )}
            />
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};

OtherSection.propTypes = {
  editMode: PropTypes.bool,
};
